function DashboardReportColumn(aUserId, aDashboardReportId, aEnrolleeReportColumnId, aSortOrder) {
    "use strict";

    this.__type = 'DashboardReportColumn:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.DashboardReportId = -1;
    if (!isNullOrUndefined(aDashboardReportId)) {
        this.DashboardReportId = aDashboardReportId;
    }
    this.EnrolleeReportColumnId = -1;
    if (!isNullOrUndefined(aEnrolleeReportColumnId)) {
        this.EnrolleeReportColumnId = aEnrolleeReportColumnId;
    }
    this.IsActive = true;
    this.SortOrder = -1;
    if (!isNullOrUndefined(aSortOrder)) {
        this.SortOrder = aSortOrder;
    }
    this.UserId = -1;
    if (!isNullOrUndefined(aUserId)) {
        this.UserId = aUserId;
    }
}
if (typeof exports !== 'undefined') {
    module.exports = DashboardReportColumn;
}